<template>
  <div tabindex="0" class="collapse collapse-arrow" ...attributes>
    <input type="checkbox" checked />
    <div class="collapse-title font-semibold">
      {{yield to="title"}}
    </div>
    <div class="collapse-content">
    {{yield to="content"}}
    </div>
  </div>
</template>
